var _a;
import { createAction, handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
var initialState = Immutable({
    message: null,
    color: null
});
var prefixActionName = 'TOAST';
var showToast = createAction("".concat(prefixActionName, "/SHOW"));
var hideToast = createAction("".concat(prefixActionName, "/HIDE"));
var actions = { showToast: showToast, hideToast: hideToast };
var reducer = handleActions((_a = {},
    _a[actions.showToast] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.merge(state, { message: payload.message, color: payload.color });
    },
    _a[actions.hideToast] = function () { return initialState; },
    _a), initialState);
export { actions as toastActions, reducer as toastReducer };
